import { useQueryPrimaryComplianceEntity } from "../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { DataView } from "../../../shared/components/DataView";

export const ReviewOriginalIndividualName: React.FC = () => {
  const queryEntity = useQueryPrimaryComplianceEntity();
  const legalName = queryEntity.data?.individualLegalName;

  return (
    <DataView
      title="Legal name"
      pill={{ text: "Original" }}
      data={[
        {
          label: "Legal first name",
          value: legalName?.givenName
        },
        {
          label: "Legal last name",
          value: legalName?.familyName
        }
      ]}
    />
  );
};
